import React from 'react';
import classnames from 'classnames';
import { default as Icon } from '../../../images/icon/4-1_ellipsis.svg';
import SVG from 'react-inlinesvg';

type IconProps = {
  className?: string;
};
const Bars: React.FC<IconProps> = props => <SVG src={Icon} className={classnames(props.className, 'icon')} />;
export default Bars;
